<template>
  <el-container>
    <el-header></el-header>
    <el-main>
      <el-row>
        <el-col>
          <h3>Elementos:</h3>
          <el-table :data="elementos" stripe style="width: 100%">
            <el-table-column type="expand">
              <template slot-scope="props">
                <el-table :data="props.row.elements">
                  <el-table-column label="Elemento" prop="elemento" width="300" />
                  <el-table-column label="Potencia" prop="acvi_potencia" width="70" />
                  <el-table-column label="Cantidad Inicial" prop="acvi_cantidad">
                    <template slot-scope="scope">
                      <el-input v-model.number="scope.row.acvi_cantidad" type="number" class="no-arrows"
                        :disabled="true"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="Expansiones" prop="acvi_expansion">
                    <template slot-scope="scope">
                      <el-input v-model.number="scope.row.acvi_expansion" type="number"
                        :style="{ width: '80px', fontSize: '12px' }"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="Retiros" prop="acvi_retiro">
                    <template slot-scope="scope">
                      <el-input v-model.number="scope.row.acvi_retiro" type="number"
                        :style="{ width: '80px', fontSize: '12px' }"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="Cantidad Final" prop="acvi_cantidad_final">
                    <template slot-scope="scope">
                      <el-input v-model.number="scope.row.acvi_cantidad_final" type="number"
                        :disabled="true"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="Vida útil" prop="acvi_vidautil">
                    <template slot-scope="scope">
                      <el-input v-model.number="scope.row.acvi_vidautil" type="number"
                        :style="{ width: '70px', fontSize: '12px' }" :disabled="true"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="Valor UC Anterior" prop="acvi_valoruc">
                    <template slot-scope="scope">
                      <el-input v-model.number="scope.row.acvi_valoruc" type="number"
                        :style="{ width: '99px', fontSize: '12px' }" :disabled="true"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="IPPo" prop="acvi_ippo">
                    <template slot-scope="scope">
                      <el-input v-model.number="scope.row.acvi_ippo" type="number" :disabled="true"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="IPPm" prop="acvi_ippm">
                    <template slot-scope="scope">
                      <el-input v-model.number="scope.row.acvi_ippm" type="number" :disabled="true"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="Valor UC Nuevo" prop="acvi_valoruc_nuevo">
                    <template slot-scope="scope">
                      <el-input v-model.number="scope.row.acvi_valoruc_nuevo" type="number"
                        :style="{ width: '99px', fontSize: '12px' }" :disabled="true"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="Valor Total Infraestructura" prop="acvi_valor_infra_nuevo">
                    <template slot-scope="scope">
                      <el-input v-model.number="scope.row.acvi_valor_infra_nuevo" type="number"
                        :style="{ width: '99px', fontSize: '12px' }" :disabled="true"></el-input>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column label="Nombre" prop="eluc_nombre" />
          </el-table>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>

export default {
  name: "AddElements",
  props: {
    elementos: {
      type: Array,
      required: true,
    },
    ippm: {
      type: Number,
      required: true,
    },
    ippo: {
      type: Number,
      required: true,
    },
  },
  watch: {
    elementos: {
      handler: function (val) {
        this.$emit("update:datos", val);
        val.forEach((type) => {
          type.elements.forEach((element) => {
            element.acvi_cantidad_final =
              element.acvi_cantidad + element.acvi_expansion - element.acvi_retiro;
            if (element.acvi_ippo !== 0) {
              const nuevoValor =
                element.acvi_valoruc * ((element.acvi_ippm) / element.acvi_ippo);
              element.acvi_valoruc_nuevo = Math.round(nuevoValor);
            } else {
              element.acvi_valoruc_nuevo = 0;
            }
            element.acvi_valor_infra_nuevo =
              element.acvi_valoruc_nuevo * element.acvi_cantidad_final;

            element.acvi_ippm = this.ippm;
            element.acvi_ippo = this.ippo;

          });
        });
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
